import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button } from '@storable/canaveral-components';
import iconMap from './iconMap';
import useCurrentPage from '../../../hooks/useCurrentPage';

const SocialMediaIcon = ({
  provider,
  link,
}) => {
  const { secondaryColorBackgroundClass,
    primaryColorBackgroundHoverClass,
    buttonStyleClass } = useCurrentPage();

  const iconClasses = cx(
    secondaryColorBackgroundClass,
    primaryColorBackgroundHoverClass,
    buttonStyleClass,
  );

  if (!iconMap[provider]) { return null; }

  return (
    <Button
      className={iconClasses}
      style={{
        color: 'white',
        height: '32px',
        width: '32px',
      }}
      componentClass="a"
      href={link}
      rel="noopener noreferrer"
      target="_blank"
      icon={iconMap[provider].icon}
      label={`${iconMap[provider].displayName}`}
      size="sm"
      shape="circle"
      context="bare"
      borderless
    />
  );
};

SocialMediaIcon.propTypes = {
  link: PropTypes.string.isRequired,
  provider: PropTypes.string.isRequired,
};

export default SocialMediaIcon;
